(function () {
  var wrapperSelector = '[data-cart-discount-code]';
  var inputSelector = '[data-cart-discount-code-input]';
  var buttonSelector = '[data-cart-discount-code-submit]';
  var messageSelector = '[data-cart-discount-code-message]';

  function shopifyRoot() {
    var root = '/';

    if (window.theme && window.theme.routes && window.theme.routes.root) {
      root = window.theme.routes.root;
    } else if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }

    return root.endsWith('/') ? root : root + '/';
  }

  function normalize(code) {
    return String(code || '').trim().toLowerCase();
  }

  function splitCodes(value) {
    var codes = [];

    String(value || '').split(',').forEach(function (code) {
      code = code.trim();

      if (code && codes.map(normalize).indexOf(normalize(code)) === -1) {
        codes.push(code);
      }
    });

    return codes;
  }

  function showMessage(wrapper, text, type) {
    var message = wrapper.querySelector(messageSelector);

    if (!message) return;

    message.textContent = text;
    message.hidden = false;
    message.classList.toggle('is-error', type === 'error');
    message.classList.toggle('is-success', type === 'success');
  }

  function setLoading(wrapper, isLoading) {
    var input = wrapper.querySelector(inputSelector);
    var button = wrapper.querySelector(buttonSelector);

    if (input) input.disabled = isLoading;

    if (button) {
      button.disabled = isLoading;
      button.textContent = isLoading ? 'APPLYING' : 'APPLY';
    }
  }

  function keepInputValue(value) {
    document.querySelectorAll(inputSelector).forEach(function (input) {
      input.value = value;
    });

    window.setTimeout(function () {
      document.querySelectorAll(inputSelector).forEach(function (input) {
        input.value = value;
      });
    }, 500);
  }

  function discountName(discount) {
    if (!discount) return '';

    return discount.code || discount.discount_code || discount.title || discount.name || '';
  }

  function appliedCodes(cart) {
    var codes = [];

    if (!cart) return codes;

    if (Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function (discount) {
        codes = codes.concat(splitCodes(discountName(discount)));
      });
    }

    if (Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        if (!Array.isArray(item.discounts)) return;

        item.discounts.forEach(function (discount) {
          codes = codes.concat(splitCodes(discountName(discount)));
        });
      });
    }

    return splitCodes(codes.join(','));
  }

  function cartHasCodes(cart, codes) {
    var applied = appliedCodes(cart).map(normalize);

    return splitCodes(codes.join(',')).every(function (code) {
      return applied.indexOf(normalize(code)) !== -1;
    });
  }

  function fetchCart() {
    return fetch(shopifyRoot() + 'cart.js', {
      headers: {
        'Accept': 'application/json',
      },
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart could not be loaded.');
      return response.json();
    });
  }

  function applyCodes(codes) {
    return fetch(shopifyRoot() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        discount: codes.join(','),
      }),
    }).then(function (response) {
      if (!response.ok) throw new Error('Discount code could not be applied.');
      return response.json();
    });
  }

  function refreshCart(cart) {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
    }

    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      bubbles: true,
      detail: {
        cart: cart,
      },
    }));
  }

  function showResult(wrapper, cart, inputValue, text, type) {
    refreshCart(cart);
    keepInputValue(inputValue);
    showMessage(wrapper, text, type);
  }

  function applyDiscount(wrapper) {
    var input = wrapper.querySelector(inputSelector);
    var inputValue = input ? input.value : '';
    var newCodes = splitCodes(inputValue);

    if (!newCodes.length) {
      showMessage(wrapper, 'Please enter a discount code.', 'error');
      if (input) input.focus();
      return;
    }

    setLoading(wrapper, true);

    fetchCart()
      .then(function (cartBeforeApply) {
        var oldCodes = appliedCodes(cartBeforeApply);
        var requestedCodes = splitCodes(oldCodes.concat(newCodes).join(','));

        return applyCodes(requestedCodes).then(function (cartAfterApply) {
          return {
            cartAfterApply: cartAfterApply,
            oldCodes: oldCodes,
            requestedCodes: requestedCodes,
          };
        });
      })
      .then(function (result) {
        var newCodeWorked = cartHasCodes(result.cartAfterApply, newCodes);
        var allCodesWorked = cartHasCodes(result.cartAfterApply, result.requestedCodes);

        if (newCodeWorked && allCodesWorked) {
          showResult(wrapper, result.cartAfterApply, inputValue, 'Nice! Your discount is now ready in your cart.', 'success');
          return;
        }

        return applyCodes(result.oldCodes).then(function (restoredCart) {
          var errorText = newCodeWorked
            ? 'That code cannot be combined with your current discount.'
            : 'That discount code was not found. Please check it and try again.';

          showResult(wrapper, restoredCart, inputValue, errorText, 'error');
        });
      })
      .catch(function () {
        showMessage(wrapper, 'Discount code could not be applied.', 'error');
      })
      .finally(function () {
        setLoading(wrapper, false);
        keepInputValue(inputValue);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(buttonSelector);
    var wrapper = button && button.closest(wrapperSelector);

    if (wrapper) applyDiscount(wrapper);
  });

  document.addEventListener('keydown', function (event) {
    var input = event.target.closest(inputSelector);
    var wrapper = input && input.closest(wrapperSelector);

    if (event.key === 'Enter' && wrapper) {
      event.preventDefault();
      applyDiscount(wrapper);
    }
  });
})();
